/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelinePropertyViaAdditionalRoomInfoDto } from './traveline-property-via-additional-room-info-dto';
import {
    TravelinePropertyViaAdditionalRoomInfoDtoFromJSON,
    TravelinePropertyViaAdditionalRoomInfoDtoFromJSONTyped,
    TravelinePropertyViaAdditionalRoomInfoDtoToJSON,
    TravelinePropertyViaAdditionalRoomInfoDtoToJSONTyped,
} from './traveline-property-via-additional-room-info-dto';

/**
 * 
 * @export
 * @interface SearchPropertiesByFilterResponse
 */
export interface SearchPropertiesByFilterResponse {
    /**
     * 
     * @type {Array<TravelinePropertyViaAdditionalRoomInfoDto>}
     * @memberof SearchPropertiesByFilterResponse
     */
    properties?: Array<TravelinePropertyViaAdditionalRoomInfoDto>;
}

/**
 * Check if a given object implements the SearchPropertiesByFilterResponse interface.
 */
export function instanceOfSearchPropertiesByFilterResponse(value: object): value is SearchPropertiesByFilterResponse {
    return true;
}

export function SearchPropertiesByFilterResponseFromJSON(json: any): SearchPropertiesByFilterResponse {
    return SearchPropertiesByFilterResponseFromJSONTyped(json, false);
}

export function SearchPropertiesByFilterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPropertiesByFilterResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'properties': json['properties'] == null ? undefined : ((json['properties'] as Array<any>).map(TravelinePropertyViaAdditionalRoomInfoDtoFromJSON)),
    };
}

  export function SearchPropertiesByFilterResponseToJSON(json: any): SearchPropertiesByFilterResponse {
      return SearchPropertiesByFilterResponseToJSONTyped(json, false);
  }

  export function SearchPropertiesByFilterResponseToJSONTyped(value?: SearchPropertiesByFilterResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'properties': value['properties'] == null ? undefined : ((value['properties'] as Array<any>).map(TravelinePropertyViaAdditionalRoomInfoDtoToJSON)),
    };
}

